// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import fastClick from 'fastclick'
import './assets/styles/reset.css'
import './assets/styles/border.css'
import store from './store/index'
import 'babel-polyfill' // 用于手机测试时不支持promise白屏的情况
import VueRouter from 'vue-router'
import { post, get } from './utils/request'
import 'lib-flexible/flexible' //自适应屏幕大小
import Vant from 'vant'
import 'vant/lib/index.css'
import { Lazyload, Toast } from 'vant'
import '@/assets/styles/change.css'
import { timeHandle, reloadPubdate } from './utils/moment'
import {isSubscribe} from '@/api/getData'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
import moment from 'moment';
Vue.prototype.$moment = moment;//赋值使用
import 'swiper/swiper-bundle.css';

import dfilters from './utils/dfilters';
for (let key in dfilters) {
    Vue.filter(key, dfilters[key]);
}
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.config.productionTip = false

fastClick.attach(document.body) // 解决移动端点击延迟
router.beforeEach((to, from, next) => {
  let integrityurl = window.location.href; // 链接重定向
  if(integrityurl == "http://study.81lianpin.com/home/8389481722034634757"){
    window.location.href = "http://study.81lianpin.com/home"  
  }else{
    //在跳转前进行一些操作，通过matched是因为层次路由 
    if (to.name === 'home' ) {
      document.title = store.state.title;
    } else {
      // if(to.name === "coursedetails") next()
      document.title = to.matched[0].meta.title; //路由跳转 
    }
  }
  // 判断是否山西专区，如果未关注公众号引导关注公众号后再进行学习
  if(to.params.id == '8602155489600970752' || (to.query.arrondiId == '8602155489600970752')) {
    isSubscribe().then(res => {
      if(!res) {
        // 未关注公众号，跳转至提示添加公众号
        next('/followofficial')
      }else{
        next()
      }
    })
  } else {
    next()
  }
});

Vue.use(VueRouter)
Vue.use(Vant)
Vue.use(Lazyload)
Vue.use(Toast)


Vue.filter('moment', timeHandle)
Vue.filter('moment', reloadPubdate)

Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.prototype.$Toast = Toast
// // v-domDrag: 标签拖拽(指令拖拽会有个点击事件，同时有点击事件和拖拽事件的不能用)
// Vue.directive('domDrag', {
//   bind(el) {
//     //el即为当前元素，添加可拖拽标识
//     el.style.cursor = 'move'
//     // 获取原有属性 ie dom.currentStyle 火狐谷歌 window.getComputedStyle(dom, null);
//     const sty = el.currentStyle || window.getComputedStyle(el, null)
//     el.onmousedown = (e) => {
//       //获取鼠标按下位置
//       const disX = e.clientX
//       const disY = e.clientY
//       // 获取当前元素的定位信息
//       // 获取到的值带px 正则匹配替换
//       let styL, styT
//       // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
//       // +的作用是将字符串转为数字
//       if (sty.left.includes('%')) {
//         styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
//         styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
//       } else {
//         styL = +sty.left.replace(/\px/g, '')
//         styT = +sty.top.replace(/\px/g, '')
//       }
//       document.onmousemove = function (e) {
//         // 通过事件委托，计算移动的距离
//         const l = e.clientX - disX
//         const t = e.clientY - disY
//         // 移动当前元素
//         el.style.left = `${l + styL}px`
//         el.style.top = `${t + styT}px`
//       }
//       //鼠标弹起，移除相应事件
//       document.onmouseup = function (e) {
//         document.onmousemove = null
//         document.onmouseup = null
//       }
//     }
//   }
// })
// 在ios上点击输入框，调取手机自带输入键盘不灵敏
fastClick.prototype.focus = function (targetElement) {
  let length;
  if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js